import { call, put, takeLatest } from 'redux-saga/effects';
import { types, actions } from '../modules/SingleCustomFinancialStatement';
import SingleCustomFinancialStatementAPIs from 'api/SingleCustomFinancialStatement';

function* watchSingleCustomFinancialStatementRequest() {
	yield takeLatest(
		types.LOAD_REQUEST,
		loadSingleCustomFinancialStatementFlow
	);
}

function* loadSingleCustomFinancialStatementFlow(action) {
	try {
		const response = yield call(
			SingleCustomFinancialStatementAPIs.load,
			action.stock_code
		);
		const responseData = response.data;

		// 檢查 responseData 是否為陣列或物件
		if (
			Array.isArray(responseData) ||
			(responseData && typeof responseData === 'object')
		) {
			yield put(
				actions.loadSingleCustomFinancialStatementCompleted(
					responseData
				)
			);
		} else {
			yield put(
				actions.loadSingleCustomFinancialStatementFailed(
					'Invalid data format'
				)
			);
		}
	} catch (error) {
		yield put(actions.loadSingleCustomFinancialStatementFailed(error));
	}
}

export default [watchSingleCustomFinancialStatementRequest()];
